import React from "react";
import {
  Button,
  Checkbox,
  Form,
  Icon,
  Input,
  message,
  Row,
  Col,
  Typography,
} from "antd";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import axios from "axios";

import { API_PATH } from "../constants/ApiPath";
import "./signin.less";

import {
  hideMessage,
  showAuthLoader,
  userFacebookSignIn,
  userGithubSignIn,
  userGoogleSignIn,
  userSignIn,
  userTwitterSignIn,
} from "appRedux/actions/Auth";
import IntlMessages from "util/IntlMessages";
import CircularProgress from "components/CircularProgress/index";

const FormItem = Form.Item;
const { Text, Title } = Typography;

class ClientSignIn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      token: localStorage.getItem("token")
        ? localStorage.getItem("token")
        : null,
      cloader: false,
    };
    // console.log(props, 'props.................>')
    if (this.state.token != null) {
      const role = localStorage.getItem("user_role")
        ? localStorage.getItem("user_role")
        : null;
      // console.log(role, 'role.........>')
      if (role === "partner") {
        this.props.history.push(
          "/detail/".concat(localStorage.getItem("user_uuid"))
        );
      } else if (
        role === "agent" ||
        role === "internal_agent" ||
        role === "qa"
      ) {
        this.props.history.push("/records");
      } else if (role === "accounts_user" || role === "finance_user") {
        this.props.history.push("/finance");
      } else if (role === "project_manager") {
        this.props.history.push("/tasks");
      } else if (role === "verify_scheduler") {
        this.props.history.push("/verify-schedule");
      } else if (role === "coordinator") {
        this.props.history.push("/tasks");
      } else if (role === "data_entry") {
        this.props.history.push("/tasks");
      } else if (
        role === "client_user" ||
        role === "client_manager" ||
        role === "client_admin"
      ) {
        this.props.history.push("/client-project-list");
      } else if (role === "qc") {
        this.props.history.push("/qc-ticket-list");
      } else if (role === "customer_connect") {
        this.props.history.push("/raw-address");
      } else if (role === "admin") {
        if (localStorage.getItem("loged_in_to") === "pmt")
          this.props.history.push("/tasks");
        else this.props.history.push("/records");
      } else {
        this.props.history.push("/not-authorized");
      }
    }
  }

  handleSubmit = (e) => {
    const { dispatch } = this.props;
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({ cloader: true });
        const user = {
          email: values.email,
          password: values.password,
        };
        const headers = {
          "Content-Type": "application/json",
          Accept: "application/json",
        };
        const endpoint = "/partner/login/";
        axios
          .post(API_PATH.concat(endpoint), user, { headers })
          .then((res) => {
            if (res.data["status"] === 200) {
              localStorage.setItem("token", res.data["token"]);
              localStorage.setItem("uuid", res.data["uuid"]);
              localStorage.setItem("user_uuid", res.data.uuid);
              // localStorage.setItem('user_role', res.data['user_role']);
              localStorage.setItem("all_roles", res.data["all_roles"]);
              dispatch(userSignIn(res.data));
              if (res.data["all_roles"].length > 1) {
                this.props.history.push("/interstitial");
              } else {
                localStorage.setItem("user_role", res.data["user_role"]);
                if (res.data["user_role"] === "partner") {
                  localStorage.setItem("loged_in_to", "orion");
                  this.props.history.push("/detail/".concat(res.data["uuid"]));
                } else if (
                  res.data["user_role"] === "agent" ||
                  res.data["user_role"] === "internal_agent" ||
                  res.data["user_role"] === "qa"
                ) {
                  localStorage.setItem("loged_in_to", "orion");
                  this.props.history.push("/records");
                } else if (
                  res.data["user_role"] === "accounts_user" ||
                  res.data["user_role"] === "finance_user"
                ) {
                  localStorage.setItem("loged_in_to", "fc");
                  this.props.history.push("/finance");
                } else if (res.data["user_role"] === "project_manager") {
                  localStorage.setItem("loged_in_to", "pmt");
                  this.props.history.push("/tasks");
                } else if (res.data["user_role"] === "verify_scheduler") {
                  localStorage.setItem("loged_in_to", "pmt");
                  this.props.history.push("/verify-schedule");
                } else if (res.data["user_role"] === "coordinator") {
                  localStorage.setItem("loged_in_to", "pmt");
                  this.props.history.push("/tasks");
                } else if (res.data["user_role"] === "data_entry") {
                  localStorage.setItem("loged_in_to", "pmt");
                  this.props.history.push("/tasks");
                } else if (
                  res.data["user_role"] === "client_user" ||
                  res.data["user_role"] === "client_manager" ||
                  res.data["user_role"] === "client_admin"
                ) {
                  localStorage.setItem("loged_in_to", "pmt");
                  this.props.history.push("/client-project-list");
                } else if (res.data["user_role"] === "qc") {
                  localStorage.setItem("loged_in_to", "pmt");
                  this.props.history.push("/qc-ticket-list");
                } else if (res.data["user_role"] === "customer_connect") {
                  localStorage.setItem("loged_in_to", "pmt");
                  this.props.history.push("/raw-address");
                } else if (res.data["user_role"] === "partner_employee") {
                  localStorage.setItem("loged_in_to", "orion");
                  this.props.history.push("/account-options");
                } else if (res.data["user_role"] === "admin") {
                  localStorage.setItem("loged_in_to", "pmt");
                  this.props.history.push("/tasks");
                } else {
                  // this.props.history.push('/records');
                  this.props.history.push("/interstitial");
                }
              }
            } else {
              this.setState({ cloader: false });
              message.error(res.data["message"]);
            }
          })
          .catch((error) => {
            this.setState({ cloader: false });
            if (error.response.status === 401) {
              message.error(error.response.data["message"]);
            } else {
              console.log(error);
              message.error(error.toString());
            }
          });
      }
    });
  };

  componentDidUpdate() {
    if (this.props.showMessage) {
      setTimeout(() => {
        this.props.hideMessage();
      }, 100);
    }
    if (this.state.token != null) {
      this.props.history.push("/dashboard");
    }
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { showMessage, loader, alertMessage } = this.props;

    return (
      <div className="gx-app-login-wrap">
        <div className="gx-app-login-container">
          <Row type="flex" align="middle" className="gx-app-login-main-content">
            <Col
              xl={12}
              lg={24}
              md={24}
              sm={24}
              xs={24}
              className="emptySpacing"
            >
              <div className="gx-app-logo-content">
                <div className="gx-app-logo-content-bg">
                  <img
                    src={require("assets/images/jetty-welcome-cropped.jpg")}
                    alt="Neature"
                  />
                </div>
              </div>
            </Col>
            <Col
              xl={12}
              lg={24}
              md={24}
              sm={24}
              xs={24}
              className="emptySpacing"
            >
              <div className="gx-app-login-content">
                <Title level={2}>Join the club</Title>
                <Text style={{ fontSize: "18px" }}>
                  Orion22 is the marketplace for Uniserved Partners to showcase
                  their skills and work on projects with the biggest names in
                  the Industry.
                </Text>
                <Form
                  onSubmit={this.handleSubmit}
                  className="gx-signin-form gx-form-row0 gx-mt-4"
                >
                  <FormItem label={<span>Email</span>}>
                    {getFieldDecorator("email", {
                      initialValue: "",
                      rules: [
                        {
                          required: true,
                          type: "email",
                          message: "The input is not valid E-mail!",
                        },
                      ],
                    })(<Input placeholder="Email" />)}
                  </FormItem>
                  <FormItem label={<span>Password</span>}>
                    {getFieldDecorator("password", {
                      initialValue: "",
                      rules: [
                        {
                          required: true,
                          message: "Please input your Password!",
                        },
                      ],
                    })(<Input type="password" placeholder="Password" />)}
                  </FormItem>
                  <br></br>
                  <FormItem>
                    <Button
                      type="primary"
                      className="gx-mb-0"
                      htmlType="submit"
                    >
                      <IntlMessages id="app.userAuth.signIn" />
                    </Button>
                    <span>
                      <IntlMessages id="app.userAuth.or" />
                    </span>{" "}
                    <Link to="/client-signup">
                      <IntlMessages id="app.userAuth.signUp" />
                    </Link>
                  </FormItem>
                </Form>
              </div>
              {this.state.cloader ? (
                <div className="gx-loader-view">
                  <CircularProgress />
                </div>
              ) : null}
              {showMessage ? message.error(alertMessage.toString()) : null}
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

const WrappedNormalLoginForm = Form.create()(ClientSignIn);

const mapStateToProps = ({ auth }) => {
  const { loader, alertMessage, showMessage, authUser, logedInUser } = auth;
  return { loader, alertMessage, showMessage, authUser, logedInUser };
};

export default connect(mapStateToProps)(WrappedNormalLoginForm);
